import {
	request
} from '@/js_sdk/request.utils.js';


export function addresscfg() {
	return request({
		url: '/api/web/addresscfg',
		method: 'POST'
	})
}

export function shouquan(data) {
	return request({
		url: '/api/web/shouquan',
		method: 'POST',
		data
	})
}

export function feedback(data) {
	return request({
		url: '/feedBack',
		method: 'POST',
		data
	})
}

export function uploadPhoto(data) {
	return request({
		url: '/review/uploadPhoto',
		method: 'POST',
		data
	})
}

// 正反面身份证判断
export function identifyFile(data) {
	return request({
		url: '/review/identifyFile',
		method: 'POST',
		data
	})
}

// 活体检测
export function liveExamination(data) {
	return request({
		url: '/review/liveExamination',
		method: 'POST',
		data
	})
}

// 记录
export function bury3Add(data={}) {
	return request({
		url: '/bury3/add',
		method: 'POST',
		data
	})
}

// 查询
export function bury3Get(data={}) {
	return request({
		url: '/bury3/pop/get',
		method: 'POST',
		data
	})
}

// 摇头晃脑活体检测-查开关
export function getLivenessFlowSwitch(data={}) {
	return request({
		url: '/review/getLivenessFlowSwitch',
		method: 'POST',
		data
	})
}

// 摇头晃脑活体检测-拿链接
export function getLivenessFlowLink(data={}) {
	return request({
		url: '/review/getLivenessFlowLink',
		method: 'POST',
		data
	})
}

// 摇头晃脑活体检测-成功时上报,参数：livenessFlowSessionId
export function uploadLivenessFlow(data={}) {
	return request({
		url: '/review/uploadLivenessFlow',
		method: 'POST',
		data
	})
}

// 根据IIN检查是否需要替换
export function checkUserIinIsExist(data={}) {
	return request({
		url: '/review/checkUserIinIsExist',
		method: 'POST',
		data
	})
}

// 替换手机号的人证比对
export function identifyUser(data={}) {
	return request({
		url: '/review/identifyUser',
		method: 'POST',
		data
	})
}

// 替换手机号注销历史手机号
export function cancelOriginalMobile(data={}) {
	return request({
		url: '/api/index/cancelOriginalMobile',
		method: 'POST',
		data
	})
}

// 新三方摇头晃脑活体检测-获取链接
export function getVeriLiveFlowId(data={}) {
	return request({
		url: '/review/getVeriLiveFlowId',
		method: 'POST',
		data
	})
}

// 新三方摇头晃脑活体检测-成功时上报,参数：veriLiveFlowId
export function getVeriLiveResult(data={}) {
	return request({
		url: '/review/getVeriLiveResult',
		method: 'POST',
		data
	})
}

// 验证用户是否在公民数据库
export function checkUserIsExistInCitizenLibrary(data={}) {
	return request({
		url: '/review/checkUserIsExistInCitizenLibrary',
		method: 'POST',
		data
	})
}